<template>
  <span class="animated-emoji-wrapper" :style="{ fontSize: size + 'px' }">
    <img
      v-if="imageUrl && !loadError"
      :src="imageUrl"
      :alt="emoji"
      class="animated-emoji"
      loading="lazy"
      @error="onError"
    />
    <span v-else class="animated-emoji-fallback">{{ emoji }}</span>
  </span>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { emojiToAnimatedUrl } from '../utils/emojiMapping';

const props = withDefaults(defineProps<{
  emoji: string;
  size?: number;
}>(), {
  size: 16,
});

const loadError = ref(false);
const imageUrl = computed(() => emojiToAnimatedUrl(props.emoji));

watch(() => props.emoji, () => {
  loadError.value = false;
});

const onError = () => {
  loadError.value = true;
};
</script>

<style scoped>
.animated-emoji-wrapper {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
}

.animated-emoji {
  width: 1.1em;
  height: 1.1em;
  display: inline-block;
  object-fit: contain;
  vertical-align: middle;
  pointer-events: none;
}

.animated-emoji-fallback {
  font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
}
</style>
